import { render, staticRenderFns } from "./54.vue?vue&type=template&id=6b008936&scoped=true&"
var script = {}
import style0 from "./54.vue?vue&type=style&index=0&id=6b008936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b008936",
  null
  
)

export default component.exports